<template>
  <sc-flex :is-column="true" :gap="4">
    <sc-layout-navitem
      @click="goHome()"
      icon="grid"
      :is-active="$route.path === '/overview' && !$route.hash"
      >Overview</sc-layout-navitem
    >
    <sc-layout-navitem
      icon="user-circle"
      @click="$router.push('/overview#clients')"
      :is-active="$route.path === '/overview' && $route.hash === '#clients'"
      >Clients</sc-layout-navitem
    >
    <!-- NOTE @chris We should have a documents overview page, separate scope. -->
    <!-- <sc-layout-navitem
      icon="files"
      @click="$router.push('/admin-documents/all')"
      :is-active="$route.path === '/admin-documents/all'"
      >Documents</sc-layout-navitem
    > -->
    <sc-layout-navitem
      v-if="allowTemplateChanges"
      icon="file"
      @click="$router.push('/questionnaire-templates')"
      :is-active="$route.path === '/questionnaire-templates'"
      >Templates</sc-layout-navitem
    >
    <sc-layout-navitem
      v-if="!isFirmCommunicationDisabled"
      @click="$router.push('/messages')"
      icon="chat"
      :count="unseenConversationsCount"
      :is-active="$route.name === 'messages'"
      >Conversations</sc-layout-navitem
    >

    <!-- Navigation block: Features -->
    <sc-layout-navitem-separator
      v-if="hasEnabledFeatures"
    ></sc-layout-navitem-separator>
    <sc-layout-navitem
      v-if="signatureRequestsEnabled"
      icon="nib"
      @click="$router.push('/overview#signature-requests')"
      :is-active="
        $route.path === '/overview' && $route.hash === '#signature-requests'
      "
      >Signature Requests</sc-layout-navitem
    >
    <sc-layout-navitem
      v-if="newTaxReturnDeliveryEnabled"
      icon="scroll"
      @click="$router.push('/overview#tax-return-delivery')"
      :is-active="
        $route.path === '/overview' && $route.hash === '#tax-return-delivery'
      "
      >Tax Return Delivery</sc-layout-navitem
    >
    <sc-layout-navitem
      v-if="allActivitiesEnabled"
      icon="pulse"
      @click="$router.push('/overview#activities')"
      :is-active="$route.path === '/overview' && $route.hash === '#activities'"
      >Activities</sc-layout-navitem
    >
    <sc-layout-navitem
      v-if="reviewAndExportEnabled"
      icon="list"
      @click="$router.push('/overview#review-export')"
      :is-active="
        $route.path === '/overview' && $route.hash === '#review-export'
      "
      >Review & Export</sc-layout-navitem
    >
    <sc-layout-navitem
      v-if="todoTasksEnabled"
      icon="list-checks"
      @click="$router.push('/overview#tasks')"
      :is-active="$route.path === '/overview' && $route.hash === '#tasks'"
      >Tasks</sc-layout-navitem
    >

    <!-- Navigation block: Firm Settings should be in it's separate block -->
    <sc-layout-navitem-separator></sc-layout-navitem-separator>
    <sc-layout-navitem
      @click="$router.push('/firm-settings')"
      :is-active="$route.path === '/firm-settings'"
      icon="firm"
      >Firm Settings</sc-layout-navitem
    >

    <!-- NOTE Left side banner example -->
    <!-- <sc-layout-navitem-separator></sc-layout-navitem-separator> -->
    <!-- <sc-layout-banner
      icon="timer"
      title="Tax Return Delivery"
      description="Available now, learn more and activate here."
    >
      <sc-button-group slot="button-group">
        <sc-button type="secondary" size="small">Dismiss</sc-button>
      </sc-button-group>
    </sc-layout-banner> -->
  </sc-flex>
</template>

<script>
import { mapGetters } from 'vuex';
import endsWith from 'lodash/endsWith';
import isEmpty from 'lodash/isEmpty';
import FirmPreferenceMixins from '../mixins/FirmPreferenceMixins';

export default {
  name: 'NavigationLeft',
  data() {
    return {
      number: 0,
    };
  },
  props: {
    unseenConversationsCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'isAdvisor',
      'navigationItems',
      'user',
      'currentFirm',
      'isFirmCommunicationDisabled',
    ]),
    allowTemplateChanges() {
      return (
        this.user &&
        this.user.firm_access !== 'basic' &&
        (!this.templateDisabledForFirmGroups ||
          this.user.firm_access !== 'group') &&
        this.user.firm_access === 'partner'
      );
    },
    hasEnabledFeatures() {
      return Boolean(
        this.newTaxReturnDeliveryEnabled ||
          this.allActivitiesEnabled ||
          this.signatureRequestsEnabled ||
          this.todoTasksEnabled,
      );
    },
  },
  mixins: [FirmPreferenceMixins],
  methods: {
    isEmpty,
    logout() {
      this.$store.dispatch('userSignOut');
    },
    endsWith,
    goHome() {
      const homeUrl = this.user.is_advisor ? '/overview' : '/';

      return this.$router.push(homeUrl);
    },
  },
};
</script>
